'use client';

import SectionHeading from './components/SectionHeading';
import Footer from './components/Footer';
import PageHeader from './components/PageHeader';
import Button from './components/Button';
import ExternalLinkIcon from './components/ExternalLinkIcon';

export default function HomePage() {
  return (
    <div className="container">
      <div className="box">
        <PageHeader />
        <SectionHeading
          roomData={null}
          heading="Seamless Livestreaming for Churches"
          subheading="Gotedo Streams is a specialised livestreaming product from the Gotedo Platform which is tailor-made for churches. Gotedo Streams allows easy streaming of your church's worship services, zonal fellowship meetings, and events."
        />

        <div className="double-button-wrapper">
          <Button
            iconPosition="right"
            icon={<ExternalLinkIcon />}
            size="sm"
            href="https://about.gotedo.com/en/products/gotedo-vineyard"
            external={true}
            target="_blank"
          >
            Get Started
          </Button>

          <Button
            iconPosition="right"
            icon={<ExternalLinkIcon />}
            variant="white-outline"
            size="sm"
            href="https://support.gotedo.com/en/docs/gotedo-vineyard/category/xdm7c0/livestreaming-module-via-gotedo-streams"
            external={true}
            target="_blank"
          >
            Read the Docs
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
